<template>
  <transition v-if="isModalMeetingVisible" name="modal-fade">
    <div class="modal-backdrop">
      <div aria-describedby="modalDescription"
           aria-labelledby="modalTitle"
           class="modal modal-custom-text"
           role="dialog"
      >

        <section
            id="modalDescription"
            class="modal-body"
        >
          <slot v-if="comments !== ''" name="body">
            Commentaire : {{ comments }}
          </slot>
          <slot v-else name="body">
            Aucun commentaire
          </slot>
        </section>

        <footer class="modal-footer">
          <button
              aria-label="Close modal"
              class="btn"
              type="button"
              @click="closeModalMeeting"
          >
            Fermer
          </button>
        </footer>
      </div>
    </div>
  </transition>

  <template v-if="!hasBookedPublicMeeting">
    <div v-if="statutEntretien === 'Oui'" class="file-section file-section--active file-section--pointer" @click="openModalMeeting">
      <div class="file-section-content">
        <div>
          <div class="file-circle file-circle--active"/>
        </div>
        <div class="file-section-content-label">Entretien de motivation</div>
        <div>
          <div class="file-icon file-icon--active"><img src="@/assets/img/file/eye.png"></div>
        </div>
      </div>
    </div>
    <div v-else-if="statutEntretien === 'Prévu' || statutEntretien === 'Proposé'" class="file-section file-section--active">
      <div class="file-section-content">
        <div>
          <div class="file-circle file-circle--active"/>
        </div>
        <div class="file-section-content-label">Entretien de motivation</div>
        <div>
          <div class="file-icon file-icon--active"><img src="@/assets/img/file/indicator.png"></div>
        </div>
      </div>

      <div class="file-section-info">
        <div class="file-section-info-separator"/>
        Vous êtes convoqué par :<br>
        {{ campusEntretien }}<br>
        <div class="file-section-info-space"/>
        <b>Le {{ dateEntretien }}</b><br>
        <div class="file-section-info-space"/>
        L'absence injustifiée à l'entretien engendrera une suppression du dossier de candidature.
      </div>
    </div>
    <div v-else-if="statutEntretien === 'Demandé' && publicMeetingList.length > 0" class="file-section">
      <div class="file-section-content ">
        <div>
          <div class="file-circle"/>
        </div>
        <div class="file-section-content-label">Entretien de motivation</div>
        <div>
          <div class="file-icon file-icon--active"><img class="penIcon" src="@/assets/img/file/pen.png"></div>
        </div>
      </div>

      <section class="file-public-calendar">
        <div >
          <div class="file-public-calendar-head">
            <h2 style="color:#0E6076">Choisissez votre date d'entretien</h2>
            <p>Les jours colorés contiennent des créneaux disponibles.</p>
          </div>

          <div v-if="publicMeetingError" class="alert alert-danger mb-0 file-public-calendar-error" role="alert">
            <button
                aria-label="Fermer le message d'erreur"
                class="file-public-calendar-error-close"
                type="button"
                @click="closePublicMeetingError"
            >
              &times;
            </button>
            {{ publicMeetingError }}
          </div>

          <div v-else-if="publicMeetingLoading" class="file-public-calendar-state">
            Chargement des créneaux...
          </div>

          <div v-else-if="publicMeetingList.length === 0" class="file-public-calendar-state">
            Aucun créneau public disponible pour le moment.
          </div>

          <template v-else>
            <div class="file-public-calendar-scroll">
              <MonthlyCalendar
                  :day-headers="calendarDayHeaders"
                  :has-content-on-date="hasPublicMeetingOnDate"
                  :is-date-selected="isPublicDateSelected"
                  :loading="calendarNavigationLoading"
                  :months="publicMonthsToDisplay"
                  @next="goNextPublicMonth"
                  @previous="goPreviousPublicMonth"
                  @day-click="handlePublicDayClick"
              />
            </div>

            <div class="file-public-calendar-actions">
              <div class="file-public-calendar-selected">
                <strong v-if="selectedPublicDate">{{ selectedPublicDateLabel }}</strong>
                <span v-else>Sélectionnez une date pour afficher les créneaux.</span>
              </div>

              <ul v-if="selectedPublicDateMeetings.length > 0" class="file-public-calendar-slot-list">
                <li v-for="meeting in selectedPublicDateMeetings" :key="meeting.id">
                  <div class="slot-main-row">
                    <div class="slot-main-left">
                      <div class="slot-row-head">
                        <strong>{{ formatPublicSlot(meeting) }}</strong>
                      </div>

                      <div class="slot-location-name">{{ getPublicMeetingLocation(meeting) }}</div>

                      <address
                          v-if="meeting?.planning?.ofCandidatureMeeting"
                          class="slot-address"
                      >
                        <div class="slot-address-line">
                          <span class="slot-address-pin">📍</span>
                          <div>
                            {{ meeting.planning.ofCandidatureMeeting.campusAddress }}<br>
                            <span class="slot-address-city">
                              {{ meeting.planning.ofCandidatureMeeting.campusPostalCode }}
                              {{ meeting.planning.ofCandidatureMeeting.campusCityName }}
                            </span>
                          </div>
                        </div>
                      </address>
                    </div>

                    <button
                        class="slot-position-btn"
                        type="button"
                        @click="handlePublicDatePositioning(meeting)"
                    >
                      📅 Se positionner
                    </button>
                  </div>
                </li>
              </ul>

              <small v-if="publicMeetingPositioningMessage" class="text-muted">
                {{ publicMeetingPositioningMessage }}
              </small>
            </div>
          </template>
        </div>
      </section>
    </div>


    <div v-else class="file-section">
      <div class="file-section-content ">
        <div>
          <div class="file-circle"/>
        </div>
        <div class="file-section-content-label">Entretien de motivation</div>
        <div>
          <div class="file-icon"><img src="@/assets/img/file/padlock-close.png"></div>
        </div>
      </div>
    </div>
  </template>

  <div v-else class="file-section file-section--active file-section--pointer" @click="openModalMeeting">
    <div class="file-section-content">
      <div>
        <div class="file-circle file-circle--active"/>
      </div>
      <div class="file-section-content-label">Entretien de motivation</div>
      <div>
        <div class="file-icon file-icon--active"><img src="@/assets/img/file/eye.png"></div>
      </div>
    </div>

    <div class="file-section-info">
      <div class="file-section-info-separator"/>
      <span v-html="bookedPublicMeetingLabel"></span><br>
      <div class="slot-main-left">
        <div class="slot-row-head">
          <strong>{{ formatPublicSlot(bookedPublicMeeting) }}</strong>
        </div>

        <div
            v-if="bookedPublicMeeting?.meetLink"
            class="slot-meet-link"
        >
          <strong style="margin-right: 12px">Lien de la visio : </strong>
          <a
              :href="bookedPublicMeeting.meetLink"
              class="slot-meet-link-anchor"
              target="_blank"
              rel="noopener noreferrer"
          >
            <i class="bi bi-camera-video-fill" aria-hidden="true"/>
            <span>{{ bookedPublicMeeting.meetLink }}</span>
          </a>
        </div>

        <address
            v-else-if="bookedPublicMeeting?.planning?.ofCandidatureMeeting"
            class="slot-address"
        >
          <div class="slot-location-name">{{ getPublicMeetingLocation(bookedPublicMeeting) }}</div>
          <div class="slot-address-line">
            <span class="slot-address-pin">📍</span>
            <div>
              {{ bookedPublicMeeting.planning.ofCandidatureMeeting.campusAddress }}<br>
              <span class="slot-address-city">
                {{ bookedPublicMeeting.planning.ofCandidatureMeeting.campusPostalCode }}
                {{ bookedPublicMeeting.planning.ofCandidatureMeeting.campusCityName }}
              </span>
            </div>
          </div>
        </address>
      </div>
      <div class="file-section-info-space"/>
      L'absence injustifiée à l'entretien engendrera une suppression du dossier de candidature.
    </div>
  </div>
</template>

<script>
import MonthlyCalendar from "@/components/UI/MonthlyCalendar.vue";
import {CALENDAR_CONFIG} from "@/constants/planning";
import PlanningApi from "@/api/PlanningApi";
import dayjs from "dayjs";
import "dayjs/locale/fr";

dayjs.locale("fr");

export default {
  name: "FileInterview",
  components: {
    MonthlyCalendar
  },
  props: {
    statutEntretien: String,
    dateEntretien: String,
    campusEntretien: String,
    comments: String
  },
  data() {
    return {
      isModalMeetingVisible: false,
      bookedPublicMeeting: null,
      publicMeetingList: [],
      publicMeetingLoading: false,
      publicMeetingError: null,
      publicMeetingPositioningMessage: '',
      currentPublicStartMonth: dayjs().startOf('month'),
      calendarNavigationLoading: false,
      selectedPublicDate: null,
      calendarDayHeaders: CALENDAR_CONFIG.DAY_HEADERS,
    }
  },
  computed: {
    publicMonthsToDisplay() {
      const months = []
      for (let i = 0; i < 1; i++) {
        const month = this.currentPublicStartMonth.add(i, 'month')
        months.push({
          key: month.format('YYYY-MM'),
          name: month.format('MMMM YYYY'),
          year: month.year(),
          monthIndex: month.month(),
          daysInMonth: month.daysInMonth(),
          firstDayOfWeek: (month.startOf('month').day() + 6) % 7
        })
      }
      return months
    },
    publicMeetingsByDate() {
      return this.publicMeetingList.reduce((groups, meeting) => {
        const dateKey = dayjs(meeting.startAt).format('YYYY-MM-DD')
        if (!groups[dateKey]) {
          groups[dateKey] = []
        }
        groups[dateKey].push(meeting)
        return groups
      }, {})
    },
    selectedPublicDateMeetings() {
      if (!this.selectedPublicDate) {
        return []
      }

      const meetings = this.publicMeetingsByDate[this.selectedPublicDate] || []
      return [...meetings].sort((a, b) => dayjs(a.startAt).valueOf() - dayjs(b.startAt).valueOf())
    },
    selectedPublicDateLabel() {
      if (!this.selectedPublicDate) {
        return ''
      }
      return dayjs(this.selectedPublicDate).format('dddd D MMMM YYYY')
    },
    hasBookedPublicMeeting() {
      return Boolean(this.bookedPublicMeeting?.id)
    },
    bookedPublicMeetingLabel() {
      const status = Number(this.bookedPublicMeeting?.statut)

      if (status === 20) {
        return "Votre rendez-vous est en attente de confirmation, s'il est confirmé vous allez recevoir prochainement une convocation par email.<br/>Sur le créneau choisi suivant :"
      }

      if (status === 30) {
        return "Nous sommes dans l'attente d'une confirmation de votre part, merci de consulter votre boîte email.<br/>Créneau concerné :"
      }

      if (status === 40) {
        return "Vous avez rendez-vous,"
      }

      if (status === 50) {
        return "Vous avez refusé la proposition de rendez-vous, merci de nous contacter pour plus d'informations.<br/><a href='/messages/contact' >Messages -> Contacter mon centre Apform</a>"
      }

      if (status === 60) {
        return "Vous avez été reçu en rendez-vous le :"
      }

      if (status === 70) {
        return "Votre rendez-vous a été annulé, merci de nous contacter pour plus d'informations."
      }


      return "Vous êtes convoqué par :"
    }
  },
  methods: {
    ensureBootstrapIconsLoaded() {
      const bootstrapIconsHref = 'https://cdn.jsdelivr.net/npm/bootstrap-icons@1.11.3/font/bootstrap-icons.css'
      const existingLink = document.querySelector(`link[href="${bootstrapIconsHref}"]`)

      if (existingLink) {
        return
      }

      const link = document.createElement('link')
      link.href = bootstrapIconsHref
      link.rel = 'stylesheet'
      document.head.appendChild(link)
    },
    closeModalMeeting() {
      this.isModalMeetingVisible = false
    },
    openModalMeeting() {
      this.isModalMeetingVisible = true
    },
    extractApiErrorMessage(error, fallbackMessage) {
      const responseData = error?.response?.data

      if (typeof responseData === 'string' && responseData.trim() !== '') {
        return responseData
      }

      const apiMessage = responseData?.detail
        || responseData?.message
        || responseData?.msg
        || responseData?.['hydra:description']
        || responseData?.title

      if (typeof apiMessage === 'string' && apiMessage.trim() !== '') {
        return apiMessage
      }

      return fallbackMessage
    },
    formatCalendarDateKey(year, monthIndex, day) {
      return `${year}-${String(monthIndex + 1).padStart(2, '0')}-${String(day).padStart(2, '0')}`
    },
    extractBookedPublicMeeting(payload) {
      if (Array.isArray(payload)) {
        return payload.find((meeting) => meeting?.id) || null
      }

      if (!payload || typeof payload !== 'object') {
        return null
      }

      if (payload.id) {
        return payload
      }

      if (payload?.meeting?.id) {
        return payload.meeting
      }

      if (payload?.bookedMeeting?.id) {
        return payload.bookedMeeting
      }

      if (Array.isArray(payload?.meetingList)) {
        return payload.meetingList.find((meeting) => meeting?.id) || null
      }

      if (payload.data) {
        return this.extractBookedPublicMeeting(payload.data)
      }

      return null
    },
    async fetchBookedPublicMeeting() {
      try {
        const response = await PlanningApi.getBookedPublicMeeting()
        this.bookedPublicMeeting = this.extractBookedPublicMeeting(response?.data)
      } catch (error) {
        this.bookedPublicMeeting = null
      }
    },
    async fetchPublicMeetings() {
      this.publicMeetingLoading = true
      this.publicMeetingError = null

      try {
        const response = await PlanningApi.getPublicMeetingsByCandidacy()
        const meetingList = response?.data?.meetingList || []
        this.publicMeetingList = [...meetingList].sort((a, b) => dayjs(a.startAt).valueOf() - dayjs(b.startAt).valueOf())

        if (this.publicMeetingList.length === 0) {
          this.selectedPublicDate = null
          return
        }

        const firstDate = dayjs(this.publicMeetingList[0].startAt).format('YYYY-MM-DD')
        this.currentPublicStartMonth = dayjs(this.publicMeetingList[0].startAt).startOf('month')
        if (!this.selectedPublicDate || !this.publicMeetingsByDate[this.selectedPublicDate]) {
          this.selectedPublicDate = firstDate
        }
      } catch (error) {
        this.publicMeetingError = this.extractApiErrorMessage(error, 'Impossible de charger les créneaux.')
      } finally {
        this.publicMeetingLoading = false
      }
    },
    hasPublicMeetingOnDate(year, monthIndex, day) {
      const dateKey = this.formatCalendarDateKey(year, monthIndex, day)
      return Boolean(this.publicMeetingsByDate[dateKey]?.length)
    },
    isPublicDateSelected(year, monthIndex, day) {
      return this.selectedPublicDate === this.formatCalendarDateKey(year, monthIndex, day)
    },
    handlePublicDayClick({year, monthIndex, day}) {
      const dateKey = this.formatCalendarDateKey(year, monthIndex, day)
      if (!this.publicMeetingsByDate[dateKey]) {
        return
      }
      this.selectedPublicDate = dateKey
      this.publicMeetingPositioningMessage = ''
    },
    goPreviousPublicMonth() {
      this.calendarNavigationLoading = true
      this.currentPublicStartMonth = this.currentPublicStartMonth.subtract(1, 'month')
      this.calendarNavigationLoading = false
    },
    goNextPublicMonth() {
      this.calendarNavigationLoading = true
      this.currentPublicStartMonth = this.currentPublicStartMonth.add(1, 'month')
      this.calendarNavigationLoading = false
    },
    formatPublicSlot(meeting) {
      if (!meeting?.startAt || !meeting?.endAt) {
        return ''
      }

      const start = dayjs(meeting.startAt).locale('fr')
      const end = dayjs(meeting.endAt).locale('fr')

      const formatHour = (d) => (d.minute() === 0 ? d.format('H[h]') : d.format('H[h]mm'))

      return `Le ${start.format('dddd D MMMM YYYY')} de ${formatHour(start)} à ${formatHour(end)}`
    },
    getPublicMeetingLocation(meeting) {
      return meeting?.planning?.ofCandidatureMeeting?.ofName || 'Lieu à confirmer'
    },
    async closePublicMeetingError() {
      this.publicMeetingError = null
      this.publicMeetingPositioningMessage = ''
      this.selectedPublicDate = null
      this.currentPublicStartMonth = dayjs().startOf('month')

      await this.fetchPublicMeetings()
    },
    async handlePublicDatePositioning(meeting) {
      if (!meeting?.id) {
        return
      }

      this.publicMeetingPositioningMessage = ''
      this.publicMeetingError = null

      try {
        const response = await PlanningApi.assignPublicMeeting(meeting.id)
        const meetingStatut = Number(response?.data?.meetingStatut)

        if (meetingStatut === 20) {
          this.publicMeetingPositioningMessage = `Votre demande de positionnement pour le rendez-vous de ${dayjs(meeting.startAt).format('HH:mm')} a bien été prise en compte.`
        }

        await this.fetchPublicMeetings()
        await this.fetchBookedPublicMeeting()
      } catch (error) {
        this.publicMeetingError = this.extractApiErrorMessage(error, 'Impossible de vous positionner sur ce créneau.')
      }
    }
  },
  mounted() {
    this.ensureBootstrapIconsLoaded()
    this.fetchBookedPublicMeeting()
    this.fetchPublicMeetings()
  }
};
</script>

<style scoped>
.file-public-calendar {
  margin-top: 1rem;
}

.file-public-calendar-card {
  background: var(--white);
  border-radius: var(--border-radius);
  box-shadow: var(--shadow);
  padding: 1.5rem;
}

.file-public-calendar-head h2 {
  color: var(--primary);
  font-size: 1.5rem;
  margin-bottom: 0.25rem;
}

.file-public-calendar-head p {
  color: var(--secondary);
  margin-bottom: 1rem;
}

.file-public-calendar-state {
  border-radius: var(--border-radius);
  border: 1px dashed #d9d9d9;
  color: #666;
  padding: 1rem;
  text-align: center;
}

.file-public-calendar-error {
  padding-right: 2.25rem;
  position: relative;
}

.file-public-calendar-error-close {
  background: transparent;
  border: 0;
  color: inherit;
  cursor: pointer;
  font-size: 1.2rem;
  line-height: 1;
  opacity: 0.8;
  padding: 0;
  position: absolute;
  right: 0.75rem;
  top: 0.75rem;
}

.file-public-calendar-error-close:hover {
  opacity: 1;
}


.file-public-calendar-scroll :deep(.nav-button),
.file-public-calendar-scroll :deep(.month-title),
.file-public-calendar-scroll :deep(.day-header)
{
  color: #0E6076;
}

.file-public-calendar-actions {
  border-top: 1px solid #ececec;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  margin-top: 1rem;
  padding-top: 1rem;
}

.file-public-calendar-selected {
  color: #0E6076;
  min-height: 1.5rem;
}

.file-public-calendar-slot-list {
  list-style: none;
  color: #0E6076;
  margin: 0;
  padding: 0;
}

.file-public-calendar-slot-list li {
  border: 1px solid #efefef;
  border-radius: 6px;
  margin-bottom: 0.5rem;
  padding: 0.6rem 0.75rem;
}

.file-public-calendar-slot-list li:last-child {
  margin-bottom: 0;
}

.slot-main-row {
  align-items: center;
  display: flex;
  gap: 0.75rem;
  justify-content: space-between;
}

.slot-main-left {
  flex: 1;
  min-width: 0;
}

.slot-row-head {
  margin-bottom: 0.2rem;
  margin-top: 0.2rem;
}

.slot-location-name {
  display: block;
  color: #676767;
  font-size: 0.9rem;
  margin-bottom: 0.25rem;
}

.slot-address {
  font-style: normal;
  margin: 0;
}

.slot-address-line {
  align-items: baseline;
  display: flex;
  gap: 8px;
}

.slot-address-pin {
  color: #e63946;
  flex-shrink: 0;
  font-size: 1.1em;
}

.slot-address-city {
  color: #666;
}

.slot-meet-link {
  margin: 0;
}

.slot-meet-link-anchor {
  align-items: center;
  color: #0e6076;
  display: inline-flex;
  gap: 0.4rem;
  text-decoration: none;
  word-break: break-all;
}

.slot-meet-link-anchor:hover {
  text-decoration: underline;
}

.slot-position-btn {
  background: #f8f9fa;
  border: 1px solid #dee2e6;
  border-radius: 999px;
  color: #6c757d;
  font-size: 0.78rem;
  font-weight: 500;
  line-height: 1;
  padding: 0.35rem 0.65rem;
  transition: all 0.2s ease;
  white-space: nowrap;
}

.slot-position-btn:hover {
  background: #eef2f5;
  border-color: #cfd6dc;
  color: #495057;
}

@media (max-width: 768px) {
  .file-public-calendar-card {
    padding: 1rem;
  }

  .slot-main-row {
    align-items: flex-start;
    flex-direction: column;
  }

  .slot-position-btn {
    align-self: flex-end;
  }
}
</style>
